import { Fancybox } from "@fancyapps/ui";


Fancybox.bind("[data-fancybox]", {
  // Your custom options
  // For example:
  closeButton: true,
  toolbar: false,
  hideScrollbar: true,
});